export class EbsSnapshotTarget {
    'region';
    'description';
    'tags';
    'snapshotEncryptionKeyId';
    'encryptionKeyId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "snapshotEncryptionKeyId",
            "baseName": "snapshotEncryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EbsSnapshotTarget.attributeTypeMap;
    }
    constructor() {
    }
}
